import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  display: flex;
  height: 73%;
  margin: 0.5em 1.75em;

  @media screen and (max-width: 812px) {
    flex-direction: column;
    align-items: center;
    height: auto;
    width: 100%;

    margin: 0.5em 0.85em;
  }
`

export const Categories = styled.div`
    display: grid;
    padding: 1% 0 0 0;
    grid-template-areas: 
      "any any"
      "any any"
      "second second";

    grid-row-gap: 2%;
    height: 100%;
    width: 30%;
    margin-right: 2em;
    align-content: center;
    justify-items: center;

    @media screen and (max-width: 812px) {
      margin: 0;
      width: 100%;
    }

    @media screen and (width: 812px) and (orientation: landscape) {
      grid-template-areas: 
        "any any any any any";
    }
`

export const Info = styled.div`
  display: flex;
  height: 100%;
  width: 70%;

  @media screen and (max-width: 812px) {
    margin: 0;
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`

export const List = styled.div`
  display: grid;
  grid-template-columns: 100%;
  align-content: flex-start;
  margin: 0.5em;
  width: 85%;
  height: 90%;

  overflow-y: auto;

  &::-webkit-scrollbar { width: 1em; }
  &::-webkit-scrollbar-track { background: #054b82; }
  &::-webkit-scrollbar-thumb { background: #dbeff5; }
  &::-webkit-scrollbar-thumb:hover { background: #fff; }

  @media screen and (max-width: 812px) {
    margin: 0;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    height: 385px;

    &::-webkit-scrollbar { width: 0.3em; }

  }

  @media screen and (max-width: 812px) and (min-height: 800px) {
    height: 540px;
  }

  @media screen and (max-width: 350px) {
    height: 300px;

    &::-webkit-scrollbar { width: 0.3em; }
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  margin: 0.5em 3em 0.5em 2.5em;

  @media screen and (max-width: 812px) {
    width: 100%;
    margin: 1em 0 0 0;
  }
`

export const Reddit = styled.img`
  position: absolute;
  bottom: 20px;
  right: 20px;

  width: 50px;
  height: 50px;

  display: block;

  &:hover{
    transform: scale(1.2)
  }
  &:active{
    transform: scale(1.1)
  }
`

export const NoChallenges = styled.div`
  display: flex;
  height: 100%;
  width: 70%;
  justify-content: center;
  align-items: center;

  text-decoration: none;
  font-family: 'Crash';
  text-align: center;
  font-size: 2em;
  transform: scaleX(0.85);
  color: #FFF;

  @media screen and (max-width: 812px) {
    margin: 0;
    width: 100%;
    height: 111px;
  }
`